/**
 * Static site configuration — compiled into the bundle (plan: "Static Assets").
 * Identity and connect channels rarely change and never need an API.
 *
 * Deliberately excluded: full name, job title, employer, live location.
 */

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://api.shvms.in').replace(/\/$/, '');

/**
 * Admin writes go to an auth proxy (Cloudflare Worker / Node-01 service) that
 * verifies the Authentik session and mints a short-lived PostgREST JWT server-side.
 * The private signing key must NEVER be shipped to the browser.
 * When unset, the admin panel is read-only.
 */
export const ADMIN_API_URL = (process.env.REACT_APP_ADMIN_API_URL || '').replace(/\/$/, '');

export const identity = {
  handle: '@shvms',
  avatarText: 'S',
  bio: 'Things I build, write and do outside the day job — updated monthly.',
};

export type ChannelIcon = 'instagram' | 'github' | 'linkedin' | 'twitter' | 'email';

export interface ConnectChannel {
  id: string;
  platform: string;
  handle: string;
  context: string;
  description: string;
  url: string;
  icon: ChannelIcon;
  accent: string;
  visible?: boolean;
  order?: number;
}

/** Plan §4 — each platform maps to a distinct part of life. */
export const connectChannels: ConnectChannel[] = [
  {
    id: 'instagram',
    platform: 'Instagram',
    handle: '@singh.shvm',
    context: 'Personal life',
    description: 'School & college friends, personal photos, travel.',
    url: 'https://instagram.com/singh.shvm',
    icon: 'instagram',
    accent: '#E1306C',
  },
  {
    id: 'linkedin',
    platform: 'LinkedIn',
    handle: 'shivamsingh361',
    context: 'Work',
    description: 'Professional network and career history.',
    url: 'https://linkedin.com/in/shivamsingh361',
    icon: 'linkedin',
    accent: '#0A66C2',
  },
  {
    id: 'github',
    platform: 'GitHub',
    handle: 'devshvms',
    context: 'Code',
    description: 'Open source and project repositories.',
    url: 'https://github.com/devshvms',
    icon: 'github',
    accent: '#E5E7EB',
  },
  {
    id: 'twitter',
    platform: 'Twitter / X',
    handle: '@dev.shvms',
    context: 'Thoughts',
    description: 'Quick thoughts and tech takes.',
    url: 'https://twitter.com/dev.shvms',
    icon: 'twitter',
    accent: '#1DA1F2',
  },
  {
    id: 'email',
    platform: 'Email',
    handle: 'dev.shvms@gmail.com',
    context: 'Direct',
    description: 'Direct contact.',
    url: 'mailto:dev.shvms@gmail.com',
    icon: 'email',
    accent: '#EFC430',
  },
];
